export default {"src":"/_next/static/media/ManyVids.e211aa89.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};